import {
  AppUpdate,
  AppUpdateAvailability,
  AppUpdateInfo,
} from '@capawesome/capacitor-app-update';
import { isPlatform } from '@ionic/core';
import { useIonModal } from '@ionic/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { AppUpdateAvailable } from '../../components/appstore/app-update-available';
import { sleep } from '../../util/async';
import { logger } from '../../util/logger';
import { useAppState } from './app-state.hook';
import { useHasFeature } from './feature.hooks';

const useAppUpdateCheck = () => {
  const [appUpdateInfo, setAppUpdateInfo] = useState<AppUpdateInfo>();

  const onClose = () => {
    dismiss();
  };

  const hasDisplayedUpdate = useRef(false);
  const forceAppUpdate = useHasFeature('beacon-app-force-update');

  const requiredUpdate = forceAppUpdate ? true : false;

  const [present, dismiss] = useIonModal(AppUpdateAvailable, {
    onClose,
    appUpdateInfo,
    requiredUpdate,
  });

  const checkForUpdate = useCallback(async () => {
    if (hasDisplayedUpdate.current) {
      return;
    }

    hasDisplayedUpdate.current = true;

    if (isPlatform('capacitor')) {
      try {
        await sleep(1000);
        logger.info('checking for update in app store');
        const results = await AppUpdate.getAppUpdateInfo();
        logger.info('done checking for update in app store', results);
        setAppUpdateInfo(results);
        if (
          results.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE
        ) {
          const breakpoints = requiredUpdate ? [0.5] : [0, 0.5];
          present({
            breakpoints,
            initialBreakpoint: 0.5,
            backdropDismiss: false,
          });
        }
      } catch (_error) {
        // ... do nothing
      }
    }
  }, [requiredUpdate, present]);

  useAppState({
    foreground: checkForUpdate,
  });
  useEffect(() => {
    checkForUpdate();
  }, [checkForUpdate]);
};

export { useAppUpdateCheck };
